<template>
  <!-- 企业邀请 -->
  <div class="firm-body">
    <!-- 标题 企业邀请 -->
    <div class="title-Individual-center">
      企业中心 <i class="el-icon-arrow-right"></i>
      <span :class="reveal == '2' ? 'span-Individual-center-active' : 'span-Individual-center'" @click="goToInvite">企业邀请</span>
      <i class="el-icon-arrow-right" v-if="reveal == '2'"></i>
      <span class="span-Individual-center" v-if="reveal == '2'">{{ InviteName || "--" }}（{{ InviteCreditCode || "--" }}）</span>
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <!-- 筛选区 -->
      <el-form class="searchRegion" :inline="true" @submit.native.prevent>
        <el-form-item label="时间：">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            unlink-panels
            clearable
            @clear="value1 = null"
          >
          </el-date-picker>
        </el-form-item>
        
      <div class="screen-end">
      <el-form-item
          :label="reveal == '1' ? '用户ID：' : '订单号：'"
          class="user-Id"
        >
          <div class="size-search" v-if="reveal == '1'">
            <el-input v-model="input" placeholder="请输入用户ID"></el-input>
          </div>
          <div class="size-search" v-else>
            <el-input v-model="input1" placeholder="请输入订单ID"></el-input>
          </div>
        </el-form-item>
      <el-form-item>
          <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
          <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
        </el-form-item>
      </div>
    
        <div class="Back" v-if="reveal == '2'" @click="handelBack"></div>
      </el-form>
      <!-- 切换 -->
      <div class="Toggle">
        <div class="Toggle-body" v-if="reveal == '1'">
          <div
            v-for="(item, index) in selectArr"
            :key="index"
            class="toggle-item"
            :class="select == item.id ? 'select-p' : ''"
            @click="handelSelect(item.id)"
          >
            {{ item.name }}({{ item.quantity }})
          </div>
        </div>
        <div class="Toggle-body Toggle-body--detail" v-if="reveal == '2'">
          <div class="Toggle-details" >充值/消费记录</div>
        </div>
        <div class="Toggle-received">
          <div class="received">
            <div class="received-body">
              <div class="img-icon"></div>
              已获侦迹币<span>{{ obtained }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div class="collected">
        <tableInvite
          v-if="reveal == '1'"
          :tableData="tableData"
          :select="select"
          @handelClickName="handelClickName"
        ></tableInvite>
        <detailsTable
          v-if="reveal == '2'"
          :tableData="DetailsData"
          @handelClickName="handelClickName"
        ></detailsTable>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging" v-if="reveal == '1'">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
        <div class="paging" v-else>
          <paging
            :pagingObj="conPagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getMyInviteRecords, // 企业中心-我的邀请记录列表
  getMyInviteRecordCount, // 查询我的邀请页面 的总数，邀请个人，邀请企业数量
  getBeInviteRechargeRecords, //查询我邀请的人充值订单记录
  getKickbackTraceCoin, //查询企业获得的返利侦迹币总额
} from "../../../../assets/api/firm/firmCenter";

// 引入分页组件
import paging from "../../../../components/paging.vue";
// 引入会员信息表格
import tableInvite from "./components/tableInvite.vue";
// 引入 提成表格
import detailsTable from "./components/detailsTable.vue";
export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 邀请列表分页数据
      conPagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 邀请人消费列表分页数据
      value1: null, // 时间搜索
      input: "", // 用户id搜索
      input1: "", // 定单编号
      selectArr: [
        { name: "会员信息", quantity: "", id: "-1" },
        { name: "个人", quantity: "", id: "0" },
        { name: "企业", quantity: "", id: "1" },
      ], // 切换 数据列表
      // quantity:{}, // 展示企业   个人 条数
      select: "-1", // 筛选
      tableData: [], //表格数据
      DetailsData: [], // 提成详情数据
      reveal: "1", // 进入到提成页面出现x点击返回
      InviteName: "", // 邀请的会员名称
      InviteCreditCode: "", // 邀请的会员信用代码
      obtained: "0", // 已获得侦迹币总数
      BeInvitedId: "", // 被邀请人id用于调用被邀请人充值记录详情列表
      Type: "", // 被邀请的是人/企业 0 / 1
    };
  },
  watch: {

  },
  components: { paging, tableInvite, detailsTable },
  created() {
    this.getKickbackTraceCoin(); //查询企业获得的返利侦迹币总额
    this.getMyInviteRecordCount(); // 查询我的邀请页面 的总数，邀请个人，邀请企业数量
    this.getMyInviteRecords(); //企业中心-我的邀请记录列表
  },
  mounted() {
    this.$bus.$on("firm-invite-reset", this.onNavReset);
  },
  beforeDestroy() {
    this.$bus.$off("firm-invite-reset", this.onNavReset);
  },
  methods: {
    goToInvite() {
     this.reveal = "1"
    },
    onNavReset() {
      if (this.reveal === "2") {
        this.handelBack();
      }
    },
    //查询我邀请的人充值订单记录
    getBeInviteRechargeRecords() {
      var data = {};
      // 处理时间
      var time;
      var timeEnd;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      data.data = {
        targetId: this.BeInvitedId, // 被邀请人 id
        orderNumber: this.input1, // 搜索-订单ID
        beInvitedType: this.Type, // 类型
        startTime: time, // 搜索/筛选传的 开始时间
        endTime: timeEnd, // 搜索/筛选传的 结束时间
      };
      getBeInviteRechargeRecords(
        data,
        this.conPagingObj.currentPage,
        this.conPagingObj.pageSize
      ).then((res) => {
        // 接口请求成功
        if (res.code == 0) {
          // list 数据总数
          this.conPagingObj.totalDevice = res.data.total;
          // 我的邀请 表格数据、
          this.DetailsData = res.data.list;
        } else {
          // 接口请求失败
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },
    //企业中心-我的邀请记录列表
    async getMyInviteRecords() {
      var data = {};
      // 处理时间
      var time;
      var timeEnd;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      data.data = {
        inviteId: this.$store.getters.getCompany.id,
        beInvitedType:
          this.select == "-1" ? "" : this.select == "0" ? "0" : "1", // 类型
        targetCode: this.input, // 目标 id
        startTime: time, // 搜索/筛选传的 开始时间
        endTime: timeEnd, // 搜索/筛选传的 结束时间
      };
      // 调用邀请列表接口
      const res = await getMyInviteRecords(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      // 接口请求成功
      if (res.code == 0) {
        // list 数据总数
        this.pagingObj.totalDevice = res.data.total;
        // 我的邀请 表格数据、
        this.tableData = res.data.list;
      } else {
        // 接口请求失败
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // 查询我的邀请页面 的总数，邀请个人，邀请企业数量
    getMyInviteRecordCount() {
      var data = {
        data: {
          inviteId: this.$store.getters.getCompany.id,
        },
      };
      getMyInviteRecordCount(data).then((res) => {
        if (res.code == 0) {
          this.selectArr[0].quantity = res.data.total;
          this.selectArr[1].quantity = res.data.personCount;
          this.selectArr[2].quantity = res.data.companyCount;
        }
      });
    },
    // 查询企业获得的返利侦迹币总额
    getKickbackTraceCoin(type, userId) {
      var data = {
        data: {
          inviterId: this.$store.getters.getCompany.id,
          inviterType: 1,
          beInvitedType: type, //被邀请类型
          beInvitedUserId: userId, //被邀请id
        },
      };
      getKickbackTraceCoin(data).then((res) => {
        if (res.code == 0) {
          this.obtained = res.data;
        }
      });
    },
    // ---------------------------------------点击查看提成详情-----------------------------
    handelClickName(val) {
      this.BeInvitedId = val.beInvitedUserId;
      this.Type = val.beInvitedType;
      this.getBeInviteRechargeRecords();
      // 获取侦迹币数量
      this.getKickbackTraceCoin(val.beInvitedType, val.beInvitedUserId);
      this.InviteName = val.beInvitedUserName || "";
      this.InviteCreditCode =
        val.creditCode || val.beInvitedCreditCode || val.beInvitedUserCode || "";
      // 显示返回按钮
      this.reveal = "2";
    },
    // 返回到正常表格

    handelBack() {
      if (this.reveal !== "2") return;
      // 恢复列表页侦迹币总数
      this.getKickbackTraceCoin();
      this.InviteName = "";
      this.InviteCreditCode = "";
      this.BeInvitedId = "";
      this.input1 = "";
      this.conPagingObj = {
        currentPage: 1,
        pageSize: 10,
        totalDevice: 0,
      };
      this.reveal = "1";
    },
    // 分页
    handleCurrentChange(val) {
      // 邀请列表分页
      if (this.reveal == "1") {
        this.pagingObj.currentPage = val;
        this.getMyInviteRecords();
      } else {
        //被邀请人消费详情列表分页
        this.conPagingObj.currentPage = val;
        this.getBeInviteRechargeRecords();
      }
    },
    //筛选 会员信息 个人 企业
    handelSelect(num) {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 邀请列表分页数据
      this.select = num;
      this.getMyInviteRecords();
    },
    //------------------------------------- 搜索按钮-----------------------------
    handelSearch() {
      // 1是搜索邀请列表数据   else搜索被邀请人消费记录详情
      if (this.reveal == "1") {
        this.pagingObj = {
          currentPage: 1, //当前页
          pageSize: 2, // 一页显示多少个
          totalDevice: 0, //用户总数
        }; // 邀请列表分页数据
        this.getMyInviteRecords();
      } else {
        this.conPagingObj = {
          currentPage: 1, //当前页
          pageSize: 10, // 一页显示多少个
          totalDevice: 0, //用户总数
        }; // 邀请人消费列表分页数据
        this.getBeInviteRechargeRecords();
      }
    },
    // ----------------------------------------重置按钮--------------------------------
    handelReset() {
      this.value1 = null;
      this.input = "";
      this.input1 = "";
      // 1重置调用 我的邀请列表    else重置调用 我邀请的用户详情列表
      if (this.reveal == "1") {
        this.pagingObj = {
          currentPage: 1, //当前页
          pageSize: 2, // 一页显示多少个
          totalDevice: 0, //用户总数
        }; // 邀请列表分页数据
        this.getMyInviteRecords();
      } else {
        this.conPagingObj = {
          currentPage: 1, //当前页
          pageSize: 10, // 一页显示多少个
          totalDevice: 0, //用户总数
        }; // 邀请人消费列表分页数据
        this.getBeInviteRechargeRecords();
      }
    },
  },
};
</script>

<style scoped lang="less">
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .firm-Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
  }
}
// 搜索区域
.searchRegion {
  margin-bottom: 0;
  position: relative;
  .Back {
    width: 20px;
    height: 20px;
    // border: 1px solid gold;
    position: absolute;
    right: 0px;
    top: 10px;
    background-image: url("../../../../assets/imgs/back-da@3x.svg");
    background-size: 100% 100%;
  }
}
// 切换导航
.Toggle {
  width: 100%;
  min-height: 35px;
  height: auto;
  line-height: 35px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  color: #333333;
  text-align: center;
  font-weight: 400;
  .Toggle-body {
    flex: 1;
    display: flex;
    font-size: 16px;
    .toggle-item {
      margin-right: 30px;
      cursor: pointer;
    }
    .select-p {
      color: #409eff ;
      box-sizing: border-box;
      border-bottom: 2px solid #409eff ;
    }
    .Toggle-avatar {
      margin-right: 16px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 35px;
      white-space: nowrap;
    }
    &.Toggle-body--detail {
      flex-direction: column;
      align-items: flex-start;
      height: auto;
      line-height: 22px;
    }
    .Toggle-details {
      height: 22px;
      line-height: 22px;
      text-align: left;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
    }
  }
  // 已得
  .Toggle-received {
    width: 350px;
    display: flex;
    justify-content: flex-end;
    .received {
      width: 160px;
      height: 35px;
      border: 1px solid #409eff ;
      border-radius: 5px;
      display: flex;
      .received-body {
        width: 140px;
        height: 20px;
        line-height: 20px;
        margin: auto;
        display: flex;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #409eff ;
        font-weight: 400;
        span {
          font-size: 16px;
          color: #fe574a;
          font-weight: 400;
          margin-left: 5px;
        }
        .img-icon {
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-image: url("../../../../assets/imgs/qianbao@3x.svg");
          background-size: 100% 100%;
        }
      }
    }
  }
}
//
.collected {
  // width: 100%;
  min-width: 1080px;
  min-height: 400px;
  margin-top: 30px;
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
